import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';

export default class GiveMeritModal extends Modal {
    amount: number = 1;
    reason: string = '';
    loading: boolean = false;

    className() {
        return 'GiveMeritModal Modal--small';
    }

    title() {
        const type = this.attrs.type;
        return type === 'merit'
            ? app.translator.trans('predictiontalk-merit-system.forum.merit.give_modal.title')
            : app.translator.trans('predictiontalk-merit-system.forum.merit.give_modal.title_smerit');
    }

    content() {
        const type = this.attrs.type;
        const charsNeeded = Math.max(0, 21 - this.reason.length);
        const user = app.session.user;

        return (
            <div className="Modal-body">
                {type === 'merit' && user && (
                    <div className="budget-info">
                        {app.translator.trans('predictiontalk-merit-system.forum.merit.give_modal.remaining_budget', {
                            remaining: user.attribute('meritSourceBudget') || 0
                        })}
                    </div>
                )}
                {type === 'smerit' && user && (
                    <div className="budget-info">
                        {app.translator.trans('predictiontalk-merit-system.forum.merit.give_modal.smerit_balance', {
                            balance: user.attribute('smeritBalance') || 0
                        })}
                    </div>
                )}
                <div className="Form-group">
                    <label>{app.translator.trans('predictiontalk-merit-system.forum.merit.give_modal.amount_label')}</label>
                    <input
                        className="FormControl"
                        type="number"
                        min="1"
                        value={this.amount}
                        oninput={(e: Event) => {
                            this.amount = parseInt((e.target as HTMLInputElement).value) || 1;
                        }}
                    />
                </div>
                <div className="Form-group">
                    <label>{app.translator.trans('predictiontalk-merit-system.forum.merit.give_modal.reason_label')}</label>
                    <textarea
                        className="FormControl"
                        rows={3}
                        placeholder={app.translator.trans('predictiontalk-merit-system.forum.merit.give_modal.reason_placeholder') as string}
                        value={this.reason}
                        oninput={(e: Event) => {
                            this.reason = (e.target as HTMLTextAreaElement).value;
                        }}
                    />
                    <div className={'chars-remaining' + (charsNeeded <= 0 ? ' chars-met' : '')}>
                        {charsNeeded > 0
                            ? app.translator.trans('predictiontalk-merit-system.forum.merit.give_modal.chars_remaining', { count: charsNeeded })
                            : '✓'
                        }
                    </div>
                </div>
                <div className="Form-group">
                    <Button
                        className="Button Button--primary"
                        loading={this.loading}
                        disabled={this.reason.length < 21 || this.amount < 1}
                        onclick={() => this.onsubmit()}
                    >
                        {type === 'merit'
                            ? app.translator.trans('predictiontalk-merit-system.forum.merit.give_modal.submit')
                            : app.translator.trans('predictiontalk-merit-system.forum.merit.give_modal.submit_smerit')
                        }
                    </Button>
                </div>
            </div>
        );
    }

    async onsubmit() {
        this.loading = true;
        m.redraw();

        const type = this.attrs.type;
        const post = this.attrs.post;
        const url = type === 'merit'
            ? app.forum.attribute('apiUrl') + '/merit/give'
            : app.forum.attribute('apiUrl') + '/merit/give-smerit';

        try {
            await app.request({
                method: 'POST',
                url,
                body: {
                    data: {
                        attributes: {
                            postId: parseInt(post.id()),
                            amount: this.amount,
                            reason: this.reason,
                        }
                    }
                }
            });

            this.hide();
            window.location.reload();
        } catch (e: any) {
            console.error(e);
            this.loading = false;
            m.redraw();
        }
    }
}
